export default function HelpPage() {
    return (
        <div className="placeholder-page" style={{ padding: '2rem', maxWidth: 720, margin: '0 auto' }}>
            <h1>Help</h1>
            <p>
                Documentation and support links coming soon. For urgent issues, email{' '}
                <a href="mailto:support@censuszen.com">support@censuszen.com</a>.
            </p>
        </div>
    );
}
